import React from 'react';
import { getDateString } from '@camp67/model';
import { Link } from '@remix-run/react';
import { FormattedString } from '../i18n/useMessages';
import { MessageKey } from '../locales/en';
import { isInquiryModeEnabled, onOpenInquiry } from '../state/inquiry-modal';

// Magh Mela 2026 Bathing Dates (Snan Dates)
export const events = [
  { name: 'paush-purnima', date: '3 Jan 2026', endDate: '5 Jan 2026' },
  { name: 'makar-sankranti', date: '14 Jan 2026', endDate: '16 Jan 2026' },
  { name: 'mauni-amavasya', date: '18 Jan 2026', endDate: '20 Jan 2026' },
  { name: 'basant-panchami', date: '23 Jan 2026', endDate: '25 Jan 2026' },
  { name: 'maghi-purnima', date: '1 Feb 2026', endDate: '3 Feb 2026' },
  { name: 'maha-shivratri', date: '15 Feb 2026', endDate: '17 Feb 2026' },
] as const;

interface Kumbh2025PageContentProps {
  contentKey: MessageKey;
  eventId: (typeof events)[number]['name'];
}

export const Kumbh2025PageContent: React.FC<Kumbh2025PageContentProps> = ({
  contentKey,
  eventId,
}) => {
  const event = events.find((e) => e.name === eventId);
  if (!event) {
    return null;
  }

  const { date, endDate } = event;

  const from = getDateString(date);
  const to = getDateString(endDate);

  return (
    <div className="flex flex-col w-full">
      <FormattedString
        message={contentKey}
        components={{
          paragraph: <p className="mt-5" />,
        }}
      />
      {isInquiryModeEnabled ? (
        <button
          onClick={() => onOpenInquiry()}
          className="px-4 py-3 mt-6 w-full md:w-[unset] bg-red-200 text-white rounded-md uppercase text-sm tracking-wider font-medium"
        >
          <FormattedString message="camp67-banner.inquire-now" />
        </button>
      ) : (
        <Link to={`/packages/reservation?from=${from}&to=${to}`} prefetch="intent">
          <button className="px-4 py-3 mt-6 w-full md:w-[unset] bg-red-200 text-white rounded-md uppercase text-sm tracking-wider font-medium">
            <FormattedString message="camp67-banner.book-now" />
          </button>
        </Link>
      )}
    </div>
  );
};
